import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useFormContext } from "react-hook-form";
import telephonyProviders from "@/config/telephony-providers.json";

export default function TelephonyTab() {
  const { control } = useFormContext();

  return (
    <div className="space-y-4">
      <FormField
        control={control}
        name="telephony_provider"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Telephony Provider</FormLabel>
            <Select
              value={field.value || "__default__"}
              onValueChange={(v) => field.onChange(v === "__default__" ? "" : v)}
            >
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder="Use server default" />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                <SelectItem value="__default__">Use server default</SelectItem>
                {telephonyProviders.providers.map((provider) => (
                  <SelectItem key={provider.id} value={provider.id}>
                    {provider.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <FormDescription>
              Carrier that places this assistant's V2 phone calls (Plivo, Vobiz, ...).
              Leave on server default unless this assistant needs a specific one — a
              caller can still override it per call.
            </FormDescription>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
}
